import React, { createContext, useContext } from 'react';
import { Archive } from 'lucide-react';

// Documents.js owns the archiving logic but the button has to live inside each
// document's own header, next to its Home button. Passing it down through every
// document component would mean touching each one's props, so the state is
// shared through context instead.
const DocumentArchiveContext = createContext(null);

export const DocumentArchiveProvider = DocumentArchiveContext.Provider;

const DocumentArchiveButton = () => {
  const archive = useContext(DocumentArchiveContext);
  if (!archive?.canArchive) return null;

  return (
    <button
      type="button"
      onClick={archive.onArchive}
      disabled={archive.isArchiving}
      className="group flex items-center justify-center w-12 h-12 flex-shrink-0 rounded-xl pvs-glass pvs-glass-hover transition-all duration-200 disabled:opacity-60"
      title={archive.isArchiving ? 'Preparing PDF...' : 'Archive (save this document as a PDF)'}
    >
      <Archive className="w-6 h-6" stroke="url(#icon-two-tone)" />
    </button>
  );
};

export default DocumentArchiveButton;
